import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fmtDate, EVENT_STATUS_LABEL } from "@/lib/content";

export default function EventRow({ ev, past = false }) {
  const d = fmtDate(ev.date);
  const badge = ev.effective_status || "upcoming";
  return (
    <Link
      to={`/dates/${ev.slug}`}
      data-testid={`event-row-${ev.slug}`}
      className={`group grid grid-cols-[64px,1fr] md:grid-cols-[110px,1fr,auto] gap-4 md:gap-8 items-center border-t border-line py-6 md:py-8 px-1 transition-colors hover:bg-panel ${
        past ? "opacity-50 hover:opacity-80" : ""
      }`}
    >
      <div className="flex md:flex-col items-baseline md:items-start gap-1.5">
        <span className="font-display text-3xl md:text-4xl leading-none">{d.day}</span>
        <span className="text-[11px] tracking-[0.25em] text-white/50">
          {d.mon}
          {d.year ? ` ’${d.year.slice(2)}` : ""}
        </span>
      </div>
      <div className="min-w-0">
        <h3 className="font-display text-2xl md:text-3xl leading-none truncate">
          {ev.title}
        </h3>
        <p className="text-xs md:text-sm text-white/50 mt-2 truncate">
          {ev.time ? `${ev.time} — ` : ""}
          {[ev.venue, [ev.city, ev.country].filter(Boolean).join(", ")]
            .filter(Boolean)
            .join(" — ")}
        </p>
      </div>
      <div className="hidden md:flex items-center gap-3">
        {ev.featured && badge !== "past" && <span className="badge badge-accent">FEATURED</span>}
        {(badge === "sold_out" || badge === "cancelled") && (
          <span className={`badge ${badge === "cancelled" ? "text-red-400" : ""}`}>
            {EVENT_STATUS_LABEL[badge]}
          </span>
        )}
        {ev.ticket_url && badge !== "past" && badge !== "cancelled" ? (
          <span className="text-[10px] tracking-[0.3em] border border-white/30 px-4 py-2 group-hover:bg-white group-hover:text-black transition-colors">
            TICKETS
          </span>
        ) : (
          <ArrowUpRight className="h-4 w-4 text-white/40" />
        )}
      </div>
    </Link>
  );
}
